/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import ListContainer from "../../../../components/_utils/CommonListView/ListContainer/index.jsx";
import ListTextWithIcon from "../../../../components/_utils/CommonListView/ListSubComponent/ListTextWithIcon/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer/index.jsx";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon/index.jsx";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import TickerAnimation from "../../../../components/_utils/TickerAnimation/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import {
  TaxAddNewLabel,
  TaxRemoveNewLabel,
} from "../../../../redux/features/accounts/taxAccount/taxAccountViewAll.js";
import { setToggle } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";

import ICONS from "../../../../assets/Icons/index.js";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import { remitterAccountViewAll } from "../../../../redux/features/accounts/remitterAccount/remitterAccount.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams.js";

const RemitterAccountViewAll = ({
  id,
  remPan,
  type,
  remAccount,
  flow,
  currentAccountDetails,
  remName,
  remIFSC,
  setModalOpen,
  setTxnPayLoad,
  onAccountSelect,
  cardsType,
  onCardNavigate,
  cardType,
  openBeneAssociate,
}) => {
  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const filterRef = useRef(null);
  const lastElementRef = useRef();
  const dropdownRef = useRef(null);
  const searchBarRefAcc = useRef(null);
  const searchBarRefAcc2 = useRef(null);
  const scrollContainerRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const [active, setActive] = useState("");
  const [labels, setLabels] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [inputData, setInputData] = useState([]);
  const [Labeldata, setLabeldata] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [accountType, setAccountType] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [LabelAccounts, setLabelAccounts] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [isWheelScrolling, setIsWheelScrolling] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const { searchParam, handleSearchParams } = useCustomSearchParams();
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [pageSize, setPageSize] = useState(
    PaginationConfiguration.paginationSmall,
  );

  const [totalCount, setTotalCount] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const [selectedValue, setSelectedValue] = useState(
    PaginationConfiguration.paginationSmall,
  );
  const [searchUserText, setSearchUserText] = useState(
    remName || searchParam.get("search") || "",
  );
  const [LabelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",") || [],
  );
  const [startDateFilter, setStartDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );
  const [accountbalancestate, setaccountbalancestate] = useState(
    searchParam.get("sort") || "",
  );
  const [currentStatus, setCurrentStatus] = useState(
    type === "RemitterAcc"
      ? ""
      : searchParam.get("status") ||
          (location?.state?.approvalStatus === "approved"
            ? "approved"
            : location?.state?.approvalStatus === "pending"
              ? "pending"
              : ""),
  );

  const { services } = useSelector((state) => state.refreshToken);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { storedPage, toggle } = useSelector(
    (state) => state.beneAllVerification,
  );

  const filteredData = accumulatedData;

  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
    });
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--awaiting)";
    }
  };

  const fetchFilterData = async () => {
    let data = [];
    setLoadingData(true);

    switch (active) {
      case "Labels":
        data = labels
          ?.filter((itm) => itm.includes(searchUserTextDebounce))
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;
      default:
        break;
    }
  };

  async function fetchViewAllData() {
    setLoading(true);
    try {
      if (currentPage === GlobalConfiguration.lengthCheckOne) {
        setLoading(true);
      }

      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
        sort_by: accountbalancestate === "Oldest first" ? "oldest" : "latest",
      };

      const addParamsBasedOnSelection = () => {
        if (searchUserText !== "") {
          queryParams.search_string = searchUserText;
        }
        if (LabelSearchText?.length !== 0) {
          queryParams.labels = LabelSearchText;
        }
        if (currentStatus !== "") {
          queryParams.approval_status = currentStatus;
        }
        if (
          startDateFilter !== "" &&
          endDateFilter !== "" &&
          !!startDateFilter &&
          !!endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date =
            startDateFilter + GlobalConfiguration.day_in_seconds;
          queryParams.end_date =
            endDateFilter + GlobalConfiguration.day_in_seconds;
        }
      };
      addParamsBasedOnSelection();

      const response = await dispatch(remitterAccountViewAll(queryParams));
      const newData = response?.payload?.remitter_accounts || [];
      setMainData(response?.payload);

      setAccumulatedData(newData);

      setTotalCount(
        response?.payload?.total_count || GlobalConfiguration.lengthCheckOne,
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  const handleSelectAll = () => {
    const filteredItems = filteredData.filter(
      (item) => item?.approval_status !== "archived",
    );

    const allIds = filteredItems.map((item) => item.id);

    const isAllSelected = allIds.every((id) => LabelAccounts.includes(id));

    if (isAllSelected) {
      setLabelAccounts([]);
    } else {
      setLabelAccounts(allIds);
    }
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);

    if (labelActionDispatchedRef.current) {
      fetchViewAllData();
      labelActionDispatchedRef.current = false;
      setLabelAccounts([]);
      setisLabelClicked(false);
      setShowSearchBar(false);
      setSearchUserText("");
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    }
  };

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleDataPopup = (data) => {
    onAccountSelect(
      data?.bank_name,
      data?.bank_acc_no,
      data?.ifsc_code,
      data?.id,
      data?.category,
      data?.pan_no,
      data?.labels,
    );
    setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountIFSC: data.ifsc_code,
      bankAccountName: data.bank_account_holder_full_name,
      bankAccountNo: data.bank_acc_no,
      bankLogo: data.bank_name,
      beneAccountId: data.id,
      pan: data.pan_no,
      labels: data.labels,
    }));
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleDateChange = (date) => {
    if (date) {
      const [start, end] = date;
      setStartDateFilter(convertDate(start));
      setEndDateFilter(convertDate(end));
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  const handleToggle = (newToggleValue) => {
    if (toggle !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
        behavior: "smooth",
      });

      if (!showSearchBar) {
        dispatch(setToggle(newToggleValue));
      }

      setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    }
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(Number(storedPage));
    toggleDropdown();
  };

  const handleKeyDown = useCallback((event) => {
    const activeElement = document.activeElement;
    const isTyping =
      activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA";

    if (
      !isTyping &&
      (event.key.toLowerCase() === "w" ||
        event.key.toLowerCase() === "s" ||
        event.key === "ArrowUp" ||
        event.key === "ArrowDown")
    ) {
      event.preventDefault();
      setIsWheelScrolling(false);
    }
  }, []);

  const handleWheel = useCallback(() => {
    setIsWheelScrolling(true);
  }, []);

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!(startDateFilter && endDateFilter) ||
        (currentStatus !== "all" && !!currentStatus) ||
        accountType !== "",
    );
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const handleClearFilters = () => {
    setCurrentStatus("");
    setAccountType("");
    setStartDateFilter("");
    setEndDateFilter("");
    setShowSearchBar(false);
    if (!(type === "RemitterAcc" && searchUserText?.length && remName !== "")) {
      setSearchUserText("");
    }
    setLabelSearchText([]);
    setisLabelClicked(false);
    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    setSearchUserTextDebounce("");
    setaccountbalancestate("");
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);

    const res = await dispatch(
      TaxAddNewLabel({
        record_ids: toArray(LabelAccounts),
        labels: labelsToAssign,
      }),
    );

    if (TaxAddNewLabel?.fulfilled?.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchViewAllData();

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (TaxAddNewLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchViewAllData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    setLoading(false);
    if (TaxAddNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const res = await dispatch(
      TaxRemoveNewLabel({
        record_ids: toArray(LabelAccounts),
        labels: labelsToUnassign,
      }),
    );

    if (TaxRemoveNewLabel?.fulfilled?.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchViewAllData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (TaxRemoveNewLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchViewAllData();
    }

    setLoading(false);
  };

  useEffect(() => {
    if (active?.length) {
      fetchFilterData();
    }
  }, [active]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const newTotalPages = Math.ceil(totalCount / pageSize);

    setCurrentPage((prevPage) => {
      if (newTotalPages === GlobalConfiguration.lengthCheckZero) {
        return GlobalConfiguration?.lengthCheckOne;
      }
      if (prevPage > newTotalPages) {
        return newTotalPages;
      }
      return prevPage;
    });
  }, [totalCount, pageSize]);

  useEffect(() => {
    dispatch(enableSwitcher());

    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    if (isLabelClicked) {
      dispatch(disableSwitcher());
    } else {
      dispatch(enableSwitcher());
    }
  }, [isLabelClicked]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("wheel", handleWheel);
    };
  }, [handleKeyDown, handleWheel]);

  useEffect(() => {
    fetchViewAllData();
    let availableLabels = sessionStorage?.getItem("TaxAvailableLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [
    markerData,
    currentStatus,
    accountType,
    currentPage,
    searchUserText,
    pageSize,
    LabelSearchText,
    accountbalancestate,
    startDateFilter,
    endDateFilter,
  ]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [startDateFilter, endDateFilter, currentStatus, accountType]);

  useEffect(() => {
    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
  }, []);

  return (
    <>
      <div
        className={`bg-primary-bg relative flex flex-col ${type === "RemitterAcc" ? "h-full" : "h-screen"}`}
        style={{
          position: type === "RemitterAcc" ? "" : "relative",
          overflow: "hidden",
          width: type === "RemitterAcc" ? "" : "var(--full-width)",
        }}
      >
        <div
          className={`${type === "RemitterAcc" ? " absolute" : "fixed"} ${showInnerSearchBar ? "z-z-index-header" : "z-z-index-dropdown"} bg-primary-nav shadow-box-shadow-top bottom-bottom-base w-full rounded-none`}
        >
          {accumulatedData?.length > GlobalConfiguration.lengthCheckZero &&
            filteredData?.length > GlobalConfiguration.lengthCheckZero && (
              <>
                <div
                  className={`${
                    showInnerSearchBar && "pointer-events-none h-full"
                  }`}
                >
                  {showInnerSearchBar && (
                    <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
                  )}
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    pageSize={pageSize}
                    dropdownOptions={PaginationConfiguration.paginationOptions}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    setIsOpen={setIsOpen}
                  />
                </div>
              </>
            )}
        </div>

        {isLabelPopupOpen && (
          <div
            onClick={() => {
              setIsLabelPopupOpen(false);
            }}
            className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
          >
            <CommonAssignLabelPopup
              headerTitle="Assign Labels"
              headersubtext="Labels will be used to generate statistics for the associated accounts."
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={LabelAccounts}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={[
                ...new Map(
                  accumulatedData?.map((item) => [item["id"], item]),
                ).values(),
              ].filter((account) => LabelAccounts.includes(account?.id))}
              onClose={handleClose}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
            />
          </div>
        )}

        <div
          className={`relative z-z-index-overlay bg-primary-nav  ${type === "RemitterAcc" ? "hidden" : "block"}`}
        >
          <div>
            <div className="hidden Qmd:block h-navbar-breadcrumb-height w-full"></div>
          </div>
        </div>

        <div className="bene_div_container Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act w-full relative">
          <TopNavComponent
            topNavCtaBtn1Needed={false}
            topNavCtaBtn1Props={
              isLabelClicked
                ? {
                    btnText: `${LabelAccounts?.length ? "Clear" : "Cancel"}`,
                    btnType: "button",
                    enabledBgColor: "var(--primary-nav-act)",
                    handleFunction: (e) => {
                      const textContent = e.target.textContent.trim();
                      if (textContent === "Clear") {
                        setLabelAccounts([]);
                      }
                      if (textContent === "Cancel") {
                        setisLabelClicked(false);
                      }
                    },
                    enabledTextColor: "var(--text-primary)",
                    isDisabled: showSearchBar,
                    hoverOption: "white",
                  }
                : undefined
            }
            topNavCtaBtn2Needed={false}
            handleBack={
              type === "RemitterAcc"
                ? undefined
                : () => {
                    navigate(-1);
                  }
            }
            topNavCtaBtn2Props={
              isLabelClicked
                ? {
                    btnText: "Assign labels",
                    btnType: "button",
                    enabledBgColor: LabelAccounts?.length
                      ? "var(--text-primary)"
                      : "var(--text-disabled)",
                    handleFunction: (e) => {
                      e.stopPropagation();
                      if (LabelAccounts?.length) {
                        setIsLabelPopupOpen(true);
                      }
                    },
                    enabledTextColor: LabelAccounts?.length
                      ? "var(--primary-bg)"
                      : "Var(--text-primary)",
                    isDisabled:
                      isLabelClicked && LabelAccounts?.length ? false : true,
                    hoverOption:
                      isLabelClicked && LabelAccounts?.length
                        ? " white"
                        : "black",
                    inActiveVariantNeeded: true,
                  }
                : undefined
            }
            BottomSubText={
              isLabelClicked
                ? "Select accounts to apply labels. Labels will be used to generate statistics for the associated remitter accounts."
                : undefined
            }
            BottomSubTextVaraint="primary"
            isSelectionView={isLabelClicked && true}
            isToggleNeeded={true}
            toggleProps={
              !isLabelClicked
                ? {
                    state: toggle,
                    title: toggle ? "Grid View" : "List View",
                    isDisabled: showSearchBar,
                    handleClick: () => handleToggle(!toggle),
                  }
                : undefined
            }
            selectionText={`Account selected - ${LabelAccounts?.length || "0"}`}
            selectionBtnProps={
              isLabelClicked
                ? {
                    btnText: "Select all",
                    btnType: "button",
                    enabledBgColor:
                      filteredData.filter(
                        (item) => item?.approval_status !== "archived",
                      )?.length === LabelAccounts?.length &&
                      !!LabelAccounts?.length
                        ? "var(--positive-bg)"
                        : "var(--primary-nav-act)",
                    handleFunction: () => {
                      handleSelectAll();
                    },
                    inActiveVariantNeeded: true,
                    enabledTextColor: "var(--text-primary)",
                    isDisabled: isLabelClicked ? false : true,
                    hoverOption:
                      filteredData.filter(
                        (item) => item?.approval_status !== "archived",
                      )?.length === LabelAccounts?.length &&
                      !!LabelAccounts?.length
                        ? ""
                        : "white",
                    icon:
                      filteredData.filter(
                        (item) => item?.approval_status !== "archived",
                      )?.length === LabelAccounts?.length &&
                      !!LabelAccounts?.length
                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                        : ICONS?.SELECT_ALL_WHITE_OUTLINE,
                  }
                : undefined
            }
            assignLabelNeeded={true}
            assignTagNeeded={true}
            // assignLabelProps={
            //   !isLabelClicked
            //     ? {
            //         handleFunction: () => {
            //           if (flow === "create" || type === "RemitterAcc") {
            //             actionRestricted();
            //             return;
            //           }
            //           if (
            //             services?.includes("ALabel") &&
            //             services?.includes("RLabel")
            //           ) {
            //             CommonToast({
            //               text: "Feature coming soon",
            //               icon: ICONS?.INFO,
            //               variant: "var(--coming-soon)",
            //               buttonNeeded: false,
            //             });
            //             // if (showSearchBar) {
            //             //   return;
            //             // }
            //             // setisLabelClicked((prev) => {
            //             //   if (prev) {
            //             //     setLabelAccounts([]);
            //             //   }
            //             //   return !prev;
            //             // });
            //           } else {
            //             navigate("/feature_not_assigned", {
            //               state: {
            //                 unavailableService: "ALabel,RLabel",
            //               },
            //             });
            //           }
            //         },
            //         isDisabled:
            //           true || // remove when labels api come
            //           showSearchBar ||
            //           flow === "create" ||
            //           type === "RemitterAcc",
            //         enabledBgColor: "var(--primary-bg)",
            //         isLoading: false,
            //         hoverOption: "white",
            //         buttonRef: null,
            //         title:
            //           "Labels will be used to generate statistics for the associated remitter accounts",
            //       }
            //     : undefined
            // }
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: loading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search remitter account",
              filterPlaceholder: "Name",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("search", val);
                    setSearchUserText(val);
                  },
                  isDropdown: false,
                  isDisabled:
                    loading ||
                    (type === "RemitterAcc" &&
                      searchUserText?.length &&
                      remName !== ""),
                },
                // {
                //   name: "Labels",
                //   short_name: "Lab",
                //   isMulti: true,
                //   value: LabelSearchText,
                //   setValue: (val) => {
                //     handleSubmit("label", val);
                //     setCurrentPage(GlobalConfiguration.lengthCheckOne);
                //     setLabelSearchText(val);
                //   },
                //   isDropdown: true,
                //   valueType: "string",
                //   isDisabled: false,
                // },
              ],
              filters: [
                {
                  name: "Account status",
                  filterType: "dropdown",
                  variant: "single",
                  size: "small",
                  value: currentStatus,
                  dropdownPlaceHolder: "Select status",
                  isDisable: false,
                  options:
                    services?.includes("REUAccount") &&
                    !services?.includes("REAAccount")
                      ? ["approved", "pending", "rejected", "archived"]
                      : [
                          "approved",
                          // "require approval",
                          "pending",
                          "rejected",
                          "archived",
                        ],
                  statusPop: true,
                  handleChange: (val) => {
                    handleSubmit("status", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentStatus(val);
                  },
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => {
                    handleSubmit("date", date);
                    handleDateChange(date);
                  },
                },
                // {
                //   name: "Account origin",
                //   filterType: "dropdown",
                //   variant: "single",
                //   size: "small",
                //   value: accountType,
                //   dropdownPlaceHolder: "Select origin",
                //   isDisable: false,
                //   options: ["New", "Edited"],
                //   statusPop: true,
                //   handleChange: (e) => setAccountType(e),
                // },
              ],
              sortByFilter: [
                {
                  name: "Newest first",
                  default: true,
                  isDisabled: false,
                },
                {
                  name: "Oldest first",
                  isDisabled: false,
                },
              ],
              sortValue: accountbalancestate,
              sortHandleChange: (val) => {
                handleSubmit("sort", val);
                setaccountbalancestate(val);
              },
              isFilterClearAllDisabled: !(
                (startDateFilter && endDateFilter) ||
                currentStatus !== "" ||
                accountType !== ""
              ),
              isSearchClearAllDisabled:
                type === "RemitterAcc" &&
                searchUserText?.length &&
                remName !== ""
                  ? true
                  : !(
                      LabelSearchText?.length ||
                      searchUserText?.length ||
                      loading
                    ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: loadingData,
              setLoading: setLoadingData,
              isShowFilter: true,
              isShowSortBy: false,
            }}
            ispagination={
              accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                ? false
                : true
            }
          />
        </div>
        {!toggle ? (
          <div
            ref={scrollContainerRef}
            tabIndex="0"
            className={`z-z-index-content overflow-y-auto ${showInnerSearchBar ? "pointer-events-none" : ""} ${isLabelClicked && " pb-padding-xl mb-margin-xl Qsmd:pb-padding-base  Qsmd:mb-margin-base"}  infinityScrollContainerAccBeneView h-height-full flex-1
            `}
            style={{
              scrollPaddingTop: "var(--padding-md)",
              scrollPaddingBottom: "var(--padding-md)",
              overflow: !isWheelScrolling && "hidden",
              marginBottom: !isWheelScrolling && "var(--margin-base)",
            }}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.preventDefault();
                return false;
              }
            }}
          >
            {showInnerSearchBar && (
              <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-header"></div>
            )}
            {loading ? (
              <div className="loader-container grid place-items-center h-full w-full">
                <Loader />
              </div>
            ) : !!filteredData?.length ? (
              <div
                className={`scroll flex flex-col items-center h-full-height overflow-y-auto scroll-py-top_md ${showInnerSearchBar && "pointer-events-none opacity-dark-opacity"} w-full ${isLabelClicked ? "mt-margin-sm pt-padding-base" : ""} `}
                ref={filterRef}
              >
                <div
                  className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md`}
                >
                  {accumulatedData?.map((account) => (
                    <>
                      <CardContainer
                        filterRef={scrollContainerRef}
                        hoverHeight={
                          GlobalConfiguration?.beneScheduleTxnCardHoverHeight
                        }
                        context={account}
                        isSelected={
                          id === account?.id
                            ? true
                            : cardType === "matchRemAcc"
                              ? selectedAccounts.includes(account.id)
                              : Array.isArray(LabelAccounts) &&
                                  LabelAccounts.includes(account.id)
                                ? true
                                : false
                        }
                        isDisabled={
                          cardType === "matchRemAcc"
                            ? ["blocked", "archived", "rejected"].includes(
                                account?.approval_status,
                              )
                            : isLabelClicked &&
                              account?.approval_status === "archived"
                        }
                        onClickHandler={(e, data) => {
                          if (flow === "create") {
                            handleDataPopup(data);
                            setModalOpen(false);
                          } else {
                            if (cardsType === "ViewOnlyCards") return;
                            if (!isLabelClicked) {
                              if (onCardNavigate) {
                                onCardNavigate(
                                  `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${account.id}`,
                                );
                                return;
                              } else if (cardType === "matchRemAcc") {
                                setSelectedAccounts((prev) =>
                                  prev.includes(account.id)
                                    ? prev.filter((id) => id !== account.id)
                                    : [...prev, account.id],
                                );
                                return;
                              } else {
                                navigate(
                                  `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${account.id}`,
                                  { replace: openBeneAssociate ? true : false },
                                );
                              }
                            } else {
                              if (LabelAccounts?.includes(account.id)) {
                                setLabelAccounts(
                                  LabelAccounts.filter(
                                    (id) => id !== account.id,
                                  ),
                                );
                              } else {
                                setLabelAccounts([
                                  ...LabelAccounts,
                                  account.id,
                                ]);
                                setLabeldata([...Labeldata, account]);
                              }
                            }
                          }
                        }}
                      >
                        <card-body>
                          {/* Account name row with optional selection icon */}
                          <TextWithIcon
                            type={"text"}
                            text={account.name
                              .toLowerCase()
                              .split(" ")
                              .map(
                                (word) =>
                                  word
                                    .charAt(
                                      GlobalConfiguration?.lengthCheckZero,
                                    )
                                    .toUpperCase() +
                                  word.slice(
                                    GlobalConfiguration?.lengthCheckOne,
                                  ),
                              )
                              .join(" ")}
                            textColor={"var(--text-primary)"}
                            subText={"Account name"}
                            iconComponentArray={[
                              ...(isLabelClicked ||
                              (cardType === "matchRemAcc" && id !== account?.id)
                                ? [
                                    {
                                      icon:
                                        selectedAccounts.includes(account.id) ||
                                        (Array.isArray(LabelAccounts) &&
                                          LabelAccounts.includes(account.id))
                                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS?.NOTSELECTED_WITH_GREY_CIRCLE,
                                      isDisabled: false,
                                    },
                                  ]
                                : []),
                            ]}
                          />

                          {/* Account status */}
                          <TextWithIcon
                            text={account?.approval_status}
                            subText={"Account status"}
                            textCase={"capitalize"}
                            fontWeight={"semibold"}
                            textColor={getStatusColor(account?.approval_status)}
                          />

                          {/* Labels */}
                          <TextWithIcon
                            text={
                              account?.labels?.join(", ") ||
                              "No labels assigned"
                            }
                            iconComponentArray={[
                              {
                                icon: ICONS?.LABEL,
                              },
                            ]}
                            fontWeight={"normal"}
                            textColor={"var(--text-primary)"}
                          />
                        </card-body>
                      </CardContainer>
                    </>
                  ))}
                </div>
              </div>
            ) : !accumulatedData?.length &&
              !filteredData?.length &&
              !loading ? (
              <div
                className="flex flex-col items-center justify-center m-auto w-full h-full "
                style={{
                  height: showSearchBar ? " var(--width-full)" : "",
                  overflowY: showSearchBar && "scroll",
                  PointerEvent: showSearchBar && "none",
                }}
              >
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className="opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm"
                />
                <p className=" text-font-sm text-text-primary items-center font-normal mb-margin-sm">
                  No data found.
                </p>
                {(searchUserText !== "" ||
                  LabelSearchText?.length > 0 ||
                  isFilterApplied) && (
                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText="Clear parameters"
                    btnType="button"
                    hoverOption="white"
                    handleFunction={() => {
                      handleClearFilters();
                    }}
                    enabledTextColor="var(--text-primary)"
                  />
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center Qsmd:absolute w-full h-full">
                <Loader />
              </div>
            )}

            <div ref={lastElementRef}></div>
          </div>
        ) : (
          <div
            ref={scrollContainerRef}
            className={`flex-1 overflow-hidden scroll-py-top_md relative ${showInnerSearchBar ? " pointer-events-none" : ""} `}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.keyCode === "83" ||
                event.keyCode === "87" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.stopPropagation();
                event.preventDefault();
                return false;
              }
              event.stopPropagation();
            }}
          >
            {showInnerSearchBar && (
              <div class="absolute bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-content"></div>
            )}
            {loading ? (
              <div className="loader-container grid place-items-center  Qsmd:absolute w-full h-full">
                <Loader />
              </div>
            ) : !!filteredData?.length ? (
              <>
                <div
                  className={`scroll flex flex-col items-center h-full overflow-y-auto scroll-py-top_md ${showInnerSearchBar && "pointer-events-none opacity-dark-opacity"} w-full ${isLabelClicked ? "mt-margin-sm pt-padding-base" : ""} `}
                  ref={filterRef}
                >
                  <div className="standard-list-view-alignment !pt-padding-md">
                    {accumulatedData.map((item) => (
                      <ListContainer
                        filterRef={scrollContainerRef}
                        // hoverHeight={
                        //   GlobalConfiguration?.beneScheduleTxnCardHoverHeight
                        // }
                        key={item.id}
                        onClickHandler={() => {
                          if (flow === "create") {
                            handleDataPopup(item);
                            setModalOpen(false);
                          } else {
                            if (cardsType === "ViewOnlyCards") return;
                            if (!isLabelClicked) {
                              if (onCardNavigate) {
                                onCardNavigate(
                                  `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${item.id}`,
                                );
                                return;
                              } else if (cardType === "matchRemAcc") {
                                setSelectedAccounts((prev) =>
                                  prev.includes(item.id)
                                    ? prev.filter((id) => id !== item.id)
                                    : [...prev, item.id],
                                );
                                return;
                              } else {
                                navigate(
                                  `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${item.id}`,
                                );
                              }
                            } else {
                              if (LabelAccounts?.includes(item.id)) {
                                setLabelAccounts(
                                  LabelAccounts.filter((id) => id !== item.id),
                                );
                              } else {
                                setLabelAccounts([...LabelAccounts, item.id]);
                                setLabeldata([...Labeldata, item]);
                              }
                            }
                          }
                        }}
                        isSelected={
                          id === item?.id
                            ? true
                            : cardType === "matchRemAcc"
                              ? selectedAccounts.includes(item.id)
                              : Array.isArray(LabelAccounts) &&
                                LabelAccounts.includes(item.id)
                        }
                        isDisabled={
                          cardType === "matchRemAcc"
                            ? ["blocked", "archived", "rejected"].includes(
                                item?.approval_status,
                              )
                            : isLabelClicked &&
                              item?.approval_status === "archived"
                        }
                        context={item}
                      >
                        <list-body>
                          <div className="w-full flex justify-between gap-x-gap-sm pt-padding-sm">
                            <div className="flex flex-col w-full">
                              <div className="w-full flex gap-x-gap-sm pr-padding-sm">
                                <p className="text-font-xs pl-padding-sm text-text-primary flex-1 truncate font-normal">
                                  <TickerAnimation
                                    text={item?.name
                                      .toLowerCase()
                                      .split(" ")
                                      .map(
                                        (word) =>
                                          word.charAt(0).toUpperCase() +
                                          word.slice(1),
                                      )
                                      .join(" ")}
                                  />
                                </p>
                                <div className="border-l border-primary-bg"></div>
                                <div className="flex gap-x-gap-sm justify-end items-center">
                                  <p
                                    style={{
                                      color: getStatusColor(
                                        item?.approval_status,
                                      ),
                                    }}
                                    className="text-font-xs font-semibold capitalize min-w-standard-approval-status-min-width text-right"
                                  >
                                    {item?.approval_status}
                                  </p>

                                  <img
                                    style={{
                                      display:
                                        isLabelClicked ||
                                        (cardType === "matchRemAcc" &&
                                          id !== item?.id)
                                          ? "flex"
                                          : "none",
                                    }}
                                    className="w-icon-sm h-icon-sm flex-shrink-0 cursor-pointer"
                                    src={
                                      selectedAccounts.includes(item.id) ||
                                      (Array.isArray(LabelAccounts) &&
                                        LabelAccounts.includes(item.id))
                                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                        : ICONS?.NOTSELECTED_WITH_GREY_CIRCLE
                                    }
                                    alt=""
                                  />
                                </div>
                              </div>

                              <ListTextWithIcon
                                type={"text"}
                                text={
                                  item?.labels?.join(", ") ||
                                  "No labels assigned"
                                }
                                iconComponentArray={[
                                  {
                                    icon: ICONS?.LABEL,
                                  },
                                ]}
                              />
                            </div>
                          </div>
                        </list-body>
                      </ListContainer>
                    ))}
                  </div>
                </div>
              </>
            ) : !accumulatedData?.length &&
              !filteredData?.length &&
              !loading ? (
              <div
                className="flex flex-col items-center justify-center m-auto w-full h-full"
                style={{
                  height: showSearchBar ? "var(--width-full)" : "",
                  overflowY: showSearchBar && "scroll",
                }}
              >
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className="opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm"
                />
                <p className="bene-acc-no-beneaccount-text mb-margin-sm">
                  No data found.
                </p>
                {(searchUserText !== "" || LabelSearchText?.length > 0) && (
                  <PrimaryButton
                    enabledBgColor="var(--primary-nav-act)"
                    btnText="Clear parameters"
                    btnType="button"
                    hoverOption="white"
                    handleFunction={() => {
                      handleClearFilters();
                    }}
                    enabledTextColor="var(--text-primary)"
                  />
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center Qsmd:absolute w-full h-full">
                <Loader />
              </div>
            )}

            <div ref={lastElementRef}></div>
          </div>
        )}

        {accumulatedData?.length > GlobalConfiguration.lengthCheckZero &&
          filteredData?.length > GlobalConfiguration.lengthCheckZero &&
          !loading && <div className="h-pagination-height flex-shrink-0"></div>}
      </div>
    </>
  );
};

export default RemitterAccountViewAll;
